import $ from 'jquery'

$(() => {
  $('.js-accordion').on('click', event => {
    const $target = $(event.currentTarget)
    $target.next().slideToggle()
    $target.toggleClass('is-opened')
  })
})
